import {
  Box,
  Stack
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const DeleteProfileImageModalContentBox = styled(Stack)(({ theme }) => ({
  alignItems:" flex-end",
  flexDirection: "column",
  gap: "24px",
  maxHeight:"calc(100% - 32px)",
  maxWidth:"45vw",
  overflowX: "hidden",
  overflowY: "auto",
  width: "fit-content",
  [theme.breakpoints.down("sm")]:{
    padding:" 16px 20px",
    maxWidth:"90vw"
  },

  "&:hover": {
    "&::-webkit-scrollbar-thumb":{
      backgroundColor: theme.customColors.systemPrimary01
    }
  },
  "::-webkit-scrollbar": {
    width: "6px"
  },
  "::-webkit-scrollbar-thumb":{
    backgroundColor: "transparent",
    borderRadius: "8px"
  },

  "& .editor-container": {
    backgroundColor: "white",
    borderRadius: "2px",
    color: "black",
    padding: "0 16px 16px"
  },

  "& .rdw-editor-toolbar": {
    border: "none",
    margin: "0px",
    padding: "16px 0px"
  },

  "& .rdw-option-wrapper": {
    border: "none"
  },

  "& .rdw-editor-main": {
    height: "200px",

    "&:hover": {
      "&::-webkit-scrollbar-thumb":{
        backgroundColor: theme.customColors.border
      }
    },
    "::-webkit-scrollbar": {
      width: "6px"
    },
    "::-webkit-scrollbar-thumb":{
      backgroundColor: "transparent",
      borderRadius: "8px"
    }
  },

  ".public-DraftStyleDefault-block": {
    margin: "0px"
  }

}));

export const StyledError = styled(Box)(({ theme }) => ({
  alignItems:"center",
  alignSelf:"flex-start",
  textAlign:"start",
  fontSize:"12px",
  color:theme.customColors.textWarning,
  display:"flex",
  gap:"8px"
}));
